import { render, staticRenderFns } from "./LookupListInput.vue?vue&type=template&id=37226afa&scoped=true&"
import script from "./LookupListInput.vue?vue&type=script&lang=js&"
export * from "./LookupListInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37226afa",
  null
  
)

export default component.exports